/*
 * @Author: WUJUN
 * @Date: 2019-10-31 11:31:36
 * @LastEditTime: 2021-10-11 17:40:59
 * @LastEditors: Please set LastEditors
 * @Description: app
 */
import { userInfo } from '_api/common';
import { WjList, countMark } from '_api/activity';
import { shoppingCarCount, AllProduct } from '_api/good';
import { getMyAddress } from '_api/address';
import { inspectLogin, loginInterface } from '_util/login';
import Cookies from 'js-cookie';
import Vue from 'vue';
// import { instance } from '_com/dialog/freeze/index';
const app = {
  state: {
    isLogin: !!Cookies.get('PIC'),
    uid: '',
    product: {},
    user: {},
    key: '',
    name: Cookies.get('name'),
    isShow: Cookies.get('isShow'),
    isWx: false,
    // 关注的游戏gid 默认不限 0
    favoriteGid: 0,
    isUC: JSON.parse(Cookies.get('UC')),
    gameList: [],
    location: '',
    showCircle: 0,
    // 20201211 当前编辑的地址信息
    editAdData: {},
    // 20201228 从实物详情页、购物车进入结算页时，将选中的商品保存
    goodsByPayList: [],
    refundOrderDetail: {}, //申请退款商品
    // 20210106订单详情修改地址
    orderDetailUpAd: [],
    goodsType: '2', //商品类型 2-虚拟商品 1-实物商品
    // 创单成功后的orderNo。结算页是否创单成功，若是则不该再停留在结算页，跳到订单详情，再清除该字段
    isCreateOrderNo: ''
  },
  getters: {
    isLogin: (state) => state.isLogin,
    uid: (state) => state.uid,
    user: (state) => state.user,
    product: (state) => state.product,
    key: (state) => state.key,
    name: (state) => state.name,
    isShow: (state) => state.isShow,
    isWx: (state) => state.isWx,
    favoriteGid: (state) => state.favoriteGid,
    isUC: (state) => state.isUC,
    gameList: (state) => state.gameList,
    location: (state) => state.location,
    showCircle: (state) => state.showCircle,
    editAdData: (state) => state.editAdData,

    goodsByPayList: (state) => state.goodsByPayList,
    refundOrderDetail: (state) => state.refundOrderDetail,
    orderDetailUpAd: (state) => state.orderDetailUpAd,
    goodsType: (state) => state.goodsType,
    isCreateOrderNo: (state) => state.isCreateOrderNo
  },
  mutations: {
    SET_IS_LOGIN: (state, v) => {
      Cookies.set('isLogin', v);
      state.isLogin = v;
    },
    SET_UID: (state, v) => {
      Cookies.set('uid', v);
      state.uid = v;
    },
    SET_USER: (state, v) => {
      state.user = v;
    },
    SET_PRODUCT: (state, v) => {
      state.product = v;
    },
    SET_KEY: (state, v) => {
      state.key = v;
    },
    SET_NAME: (state, v) => {
      Cookies.set('name', v);
      state.name = v;
    },
    SET_ISSHOW: (state, v) => {
      Cookies.set('isShow', v);
      state.isShow = v;
    },
    SET_ISWX: (state, v) => {
      state.isWx = v;
    },
    SET_LIST: (state, v) => {
      let data = v;
      if (!data) {
        data = 0;
      }
      state.favoriteGid = Number(data);
    }, //设置关注产品列表
    SET_GAHELIST: (state, v) => {
      state.gameList = v;
    },
    SET_LOCATION: (state, v) => {
      state.location = v;
    },
    SET_CIRCLE_FLAG: (state, v) => {
      state.showCircle = v;
    },
    // 编辑地址时，保存当前地址信息
    SET_EDIT_AD_DATA(state, data) {
      state.editAdData = data;
    },

    // 20201228 从实物详情页、购物车进入结算页时，将选中的商品保存
    SET_GOODS_BY_PAY(state, data) {
      state.goodsByPayList = data;
    },
    SET_REFUND_ORDER_DETAIL(state, data) {
      state.refundOrderDetail = data;
    },
    SET_ORDER_DETAIL_UP_AD(state, data) {
      state.orderDetailUpAd = data;
    },
    SET_GOODS_TYPE(state, data) {
      state.goodsType = data;
    },
    SET_CREATEORDER(state, data) {
      state.isCreateOrderNo = data;
    }
  },
  actions: {
    getUserInfo: async ({ commit, state }, array) => {
      try {
        let isLogin = PLUGIN.getUserInfo();
        if (isLogin) {
          let { uid } = inspectLogin();
          let { obj } = await userInfo({
            uid: uid,
            source: state.key
          });
          if (obj) {
            commit('SET_USER', obj);
          }
        }
      } catch (err) {
        commit('SET_IS_LOGIN', false);
      }
    },
    getLocation: async ({ commit, state }, array) => {
      try {
        let { obj } = await WjList();
        commit('SET_LOCATION', obj.url);
      } catch (err) {
        commit('SET_LOCATION', '');
      }
    },
    getCircle: async ({ commit, state }, array) => {
      try {
        let { obj } = await countMark({
          uid: state.uid
        });
        let flag = false;
        obj > 0 ? (flag = true) : (flag = false);
        commit('SET_CIRCLE_FLAG', flag);
      } catch (err) {
        console.log(err);
      }
    },
    // 获取我的地址列表
    acGetAddressList: ({ state }, page = {}) => {
      try {
        return new Promise((resolve, reject) => {
          getMyAddress({ uid: state.uid, ...page })
            .then((res) => {
              resolve(res);
            })
            .catch((e) => {
              reject(e);
            });
        });
      } catch (e) {}
    },

    // 获取购物车数量
    acShoppingCarCount: ({ state }) => {
      try {
        return new Promise((resolve, reject) => {
          shoppingCarCount({ uid: state.uid })
            .then((res) => {
              resolve(res);
            })
            .catch((e) => {
              reject(e);
            });
        });
      } catch (e) {}
    },

    login: ({ commit, state }, param) => {
      let isSwitch = !!param,
        callback;

      if (typeof param === 'object' && param !== null) {
        isSwitch = param.flag;
        callback = param.callback;
      }
      console.log('isSwitch: ', isSwitch);
      let isApp = PLUGIN.isApp;
      new PLUGIN().login({
        isUtc: !isApp,
        isSwitch,
        data: {
          checkLoginUrl: '/web/common/hwyAppCheckLogin'
        },
        success: async function(data) {
          try {
            commit('SET_LIST', 0);
            commit('SET_IS_LOGIN', true);
            let { uid } = inspectLogin();
            if (!uid) {
              return;
            }
            if (!localStorage.getItem(`${uid}-visited`)) {
              setTimeout(() => {
                Vue.prototype.$_dialog.toogle();
              });
              localStorage.setItem(`${uid}-visited`, '0');
            } else {
              commit('SET_LIST', localStorage.getItem(`${uid}-visited`));
            }
            if (sessionStorage.getItem('uid')) {
              if (uid !== sessionStorage.getItem('uid')) {
                await loginInterface();
                sessionStorage.setItem('uid', uid);
                if (data.external) {
                  setTimeout(() => {
                    Vue.prototype.$_dialog.account();
                  });
                } else {
                  window.history.go(0);
                }
              }
            } else {
              await loginInterface();
              sessionStorage.setItem('uid', uid);
            }
            callback && callback();
          } catch (err) {
            // reject(err);
            console.log(err);
          }
        },
        error: function(data) {
          console.log('errorerror');
          commit('SET_IS_LOGIN', false);
        }
      });
    },
    getGameLists: async ({ commit, state }) => {
      try {
        const { obj } = await AllProduct();
        commit('SET_GAHELIST', obj);
      } catch (err) {
        console.log(err);
      }
    }
  }
};

export default app;



// WEBPACK FOOTER //
// src/store/modules/app.js